// src/components/BotaoBoletoDeletar.jsx
import React from 'react';
import { useHttpClient } from '../hooks/useHttpClient';
import { usePreventDoubleClick } from '../hooks/usePreventDoubleClick';
import { useNotificacoes } from '../hooks/useNotificacoes';

import styles from './BotaoBoletoDeletar.module.css';

function BotaoBoletoDeletar({ idConsumo, className = '', children }) {
    const { del } = useHttpClient();
    const { exibirErro, exibirSucesso } = useNotificacoes();

    async function deletarBoleto() {
        try {
            const response = await del(`/hello-sol/boletos/${idConsumo}`);
            exibirSucesso(response?.mensagem || 'Boleto excluído com sucesso');
        } catch (err) {
            exibirErro(err?.message || 'Erro ao excluir boleto');
        }
    }

    const [safeDeletar, isDeletando] =
        usePreventDoubleClick(deletarBoleto);

    return (
        <button
            type="button"
            onClick={safeDeletar}
            disabled={isDeletando}
            className={`${styles.botaoLixeira} ${className}`}
            aria-label="Excluir boleto"
        >
            {isDeletando ? '…' : children}
        </button>
    );
}

export default BotaoBoletoDeletar;
